import type { QueryClient } from "@tanstack/react-query";

export function refreshRecorderQueries(client: QueryClient): Promise<unknown[]> {
  return Promise.all([
    client.invalidateQueries({ queryKey: ["getBaumobilErfasser"] }),
    client.invalidateQueries({ queryKey: ["getNull"] }),
  ]);
}
